import React, { useState, useEffect } from "react";
import { Button, Card, Col, Collapse, Form, Input, message, Row, Spin, Select, Upload, InputNumber } from "antd";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { getToken } from "../../helpers";
import { useParams, useNavigate } from "react-router-dom";
import { CopyOutlined, CameraOutlined } from '@ant-design/icons';
import imageCompression from 'browser-image-compression'; // Importa la biblioteca

const { Dragger } = Upload;
const { Option } = Select;
const { Panel } = Collapse;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isMobile;
};

const UpdateVisit = () => {
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useIsMobile();
  const [activeMarca, setActiveMarca] = useState(['0']);
  const { user } = useAuthContext();
  const params = useParams();
  const { visitaId } = params;
  const [visitData, setVisitaData] = useState(null);
  const [marcas, setMarcas] = useState([]); // Estado que almacena las marcas
  const [imagenes, setImagenes] = useState([]);
  const [imagenesNuevas, setImagenesNuevas] = useState([]);
  const [textAreaValue, setTextAreaValue] = useState('');
  const [implantacionTypes, setImplantacionTypes] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  
  const marcasSelect = [
    "ARGON18", "AVID", "BELL","BLACKBURN","BLUM","CAMELBAK","C-PREME","CRANKBROTHERS","ENDURO BEARINGS",
    "FIDLOCK", "FIZIK", "FIZIK COMPONENTES", "FIZIK SILLINES", "FIZIK ZAPATILLAS",
    "FINISH LINE", "GENUINE INNOVATIONS", "GIRO CALCETINES", "GIRO CASCOS",
    "GIRO GUANTES", "GIRO NEW ROAD", "GIRO ZAPATILLAS", "HAWKERS",
    "LEZYNE", "LIZARD SKINS","MAXXIS","OFERTAS", "ONOFF", "PARK TOOL","PELOTAN",
    "QUARQ", "ROCKSHOX", "SANTA MADRE", "SELLE ROYAL", "SENSUS", "SLIME","SOARING",
    "SRAM", "TIME", "TOWCAR", "TROY LEE DESIGNS", "TUBOLIGHT", "UTO", "X-SAUCE",
    "ZIPP", "OTROS"
  ];

  useEffect(() => {
    const fetchVisitaData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API}/visitas/${visitaId}?populate=*`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        });

        const data = await response.json();

        if (data && data.data && data.data.attributes) {
          setVisitaData(data);
          setImagenes(data.data.attributes.imagenes.data);

          const attributes = data.data.attributes;
          let tempMarcas = [];
          for (let i = 0; i <= 9; i++) { 
            let marca = attributes["marca" + i];
            if (marca !== null && marca !== undefined) {
              tempMarcas.push(marca);
            }
          }
          setMarcas(tempMarcas);
        }

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        message.error("Error while fetching visit data!");
      }
    };

    fetchVisitaData();
  }, [visitaId]);

  useEffect(() => {
    const fetchImplantacionTypes = async () => {
      try {
        const response = await fetch(`${API}/implantaciontypes`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        });
        const data = await response.json();
        const filteredData = data.data
          .filter(item => item.attributes.Name && item.attributes.Name.startsWith("IMP "))
          .filter(item => item.attributes.U_TB_VENTA === "SI")
          .sort((a, b) => a.attributes.Name.localeCompare(b.attributes.Name));

        setImplantacionTypes(filteredData);
      } catch (error) {
        message.error("Error while fetching implantation types!");
      }
    };

    fetchImplantacionTypes();
  }, []);

  // Función para comprimir imágenes
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5, // Máximo 500KB
      maxWidthOrHeight: 1000, // Máximo 1000px de ancho o alto
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      console.error("Error al comprimir la imagen:", error);
      return file; // Si falla la compresión, devuelve el archivo original
    }
  };

  const handleClientesClick = () => {
    navigate(`/clients`);
  };

  const handleProfileUpdate = async (data) => {
    setLoading(true);
    let uploadedImages = [];
    
    const uploadImages = async () => {
      const formData = new FormData();
      imagenesNuevas.forEach(img => {
        formData.append('files', img);
      });
  
      const response = await fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error("Failed to upload images");
      }
  
      return await response.json();
    };
    
    if (imagenesNuevas && imagenesNuevas.length > 0) {
      const newImages = await uploadImages();
      uploadedImages = newImages ? [...newImages] : [];
      data.imagenes = [
        ...uploadedImages.map(img => img.id),
        ...(imagenes ? imagenes.map(img => img.id) : [])
      ];
    } else {
      data.imagenes = imagenes ? imagenes.map(img => img.id) : [];
    }

    try {
      if (user && user.id) {
        const response = await fetch(`${API}/visitas/${visitaId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({ data }),
        });
  
        if (!response.ok) {
          throw new Error("Failed to submit form");
        }
  
        message.success("Visita actualizada correctamente");
      } else {
        message.error("Ha ocurrido un error");
      }
    } catch (error) {
      message.error("Ha ocurrido un error");
    } finally {
      setLoading(false);
      handleClientesClick();
    }
  };

  // Añadir una nueva marca
  const addMarca = () => {
    if (marcas.length < 9) {
      const newIndex = marcas.length;
      setMarcas([...marcas, `Marca ${newIndex + 1}`]);
      setActiveMarca([String(newIndex)]);
    } else {
      message.error("No puedes añadir más de 9 marcas");
    }
  };

  // Eliminar imagen
  const handleDeleteImage = async (imageId) => {
    try {
      const response = await fetch(`${API}/upload/files/${imageId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      if (response.ok) {
        setImagenes(imagenes.filter(img => img.id !== imageId));
        message.success("Imagen eliminada correctamente");
      } else {
        throw new Error("Error al eliminar la imagen");
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <Card className="profile_page_card">
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          lugar:  visitData ? visitData.data.attributes.lugar : "error", 
          tipo:  visitData ? visitData.data.attributes.tipo : "error",
          report :  visitData ? visitData.data.attributes.report : "error",
          tiene_web: visitData && visitData.data.attributes.tiene_web !== undefined ? visitData.data.attributes.tiene_web : false, 
          plataforma: visitData && visitData.data.attributes.plataforma !== undefined ? visitData.data.attributes.plataforma : "", 
          reportPersonal :  visitData ? visitData.data.attributes.reportPersonal : "error",
          marca0:  visitData ? visitData.data.attributes.marca0 : "error",
          marca1:  visitData ? visitData.data.attributes.marca1 : "error",
          marca2:  visitData ? visitData.data.attributes.marca2 : "error",
          marca3:  visitData ? visitData.data.attributes.marca3 : "error",
          marca4:  visitData ? visitData.data.attributes.marca4 : "error",
          marca5:  visitData ? visitData.data.attributes.marca5 : "error",
          marca6:  visitData ? visitData.data.attributes.marca6 : "error",
          marca7:  visitData ? visitData.data.attributes.marca7 : "error",
          marca8:  visitData ? visitData.data.attributes.marca8 : "error",
          marca9:  visitData ? visitData.data.attributes.marca9 : "error",
          marca10:  visitData ? visitData.data.attributes.marca10 : "error",
          pedido0:  visitData ? visitData.data.attributes.pedido0 : "error",
          pedido1:  visitData ? visitData.data.attributes.pedido1 : "error",
          pedido2:  visitData ? visitData.data.attributes.pedido2 : "error",
          pedido3:  visitData ? visitData.data.attributes.pedido3 : "error",
          pedido4:  visitData ? visitData.data.attributes.pedido4 : "error",
          pedido5:  visitData ? visitData.data.attributes.pedido5 : "error",
          pedido6:  visitData ? visitData.data.attributes.pedido6 : "error",
          pedido7:  visitData ? visitData.data.attributes.pedido7 : "error",
          pedido8:  visitData ? visitData.data.attributes.pedido8 : "error",
          pedido9:  visitData ? visitData.data.attributes.pedido9 : "error",
          pedido10:  visitData ? visitData.data.attributes.pedido10 : "error",
          descuento0:  visitData ? visitData.data.attributes.descuento0 : "error",
          descuento1:  visitData ? visitData.data.attributes.descuento1 : "error",
          descuento2:  visitData ? visitData.data.attributes.descuento2 : "error",
          descuento3:  visitData ? visitData.data.attributes.descuento3 : "error",
          descuento4:  visitData ? visitData.data.attributes.descuento4 : "error",
          descuento5:  visitData ? visitData.data.attributes.descuento5 : "error",
          descuento6:  visitData ? visitData.data.attributes.descuento6 : "error",
          descuento7:  visitData ? visitData.data.attributes.descuento7 : "error",
          descuento8:  visitData ? visitData.data.attributes.descuento8 : "error",
          descuento9:  visitData ? visitData.data.attributes.descuento9 : "error",
          descuento10:  visitData ? visitData.data.attributes.descuento10 : "error",
          formaPago0:  visitData ? visitData.data.attributes.formaPago0 : "error",
          formaPago1:  visitData ? visitData.data.attributes.formaPago1 : "error",
          formaPago2:  visitData ? visitData.data.attributes.formaPago2 : "error",
          formaPago3:  visitData ? visitData.data.attributes.formaPago3 : "error",
          formaPago4:  visitData ? visitData.data.attributes.formaPago4 : "error",
          formaPago5:  visitData ? visitData.data.attributes.formaPago5 : "error",
          formaPago6:  visitData ? visitData.data.attributes.formaPago6 : "error",
          formaPago7:  visitData ? visitData.data.attributes.formaPago7 : "error",
          formaPago8:  visitData ? visitData.data.attributes.formaPago8 : "error",
          formaPago9:  visitData ? visitData.data.attributes.formaPago9 : "error",
          formaPago10:  visitData ? visitData.data.attributes.formaPago10 : "error",
          reporteMarca0:  visitData ? visitData.data.attributes.reporteMarca0 : "error",
          reporteMarca1:  visitData ? visitData.data.attributes.reporteMarca1 : "error",
          reporteMarca2:  visitData ? visitData.data.attributes.reporteMarca2 : "error",
          reporteMarca3:  visitData ? visitData.data.attributes.reporteMarca3 : "error",
          reporteMarca4:  visitData ? visitData.data.attributes.reporteMarca4 : "error",
          reporteMarca5:  visitData ? visitData.data.attributes.reporteMarca5 : "error",
          reporteMarca6:  visitData ? visitData.data.attributes.reporteMarca6 : "error",
          reporteMarca7:  visitData ? visitData.data.attributes.reporteMarca7 : "error",
          reporteMarca8:  visitData ? visitData.data.attributes.reporteMarca8 : "error",
          reporteMarca9:  visitData ? visitData.data.attributes.reporteMarca9 : "error",
          reporteMarca10:  visitData ? visitData.data.attributes.reporteMarca10 : "error",
          implantacionMarca0: visitData ? visitData.data.attributes.implantacionMarca0 : "error",
          implantacionMarca1: visitData ? visitData.data.attributes.implantacionMarca1 : "error",
          implantacionMarca2: visitData ? visitData.data.attributes.implantacionMarca2 : "error",
          implantacionMarca3: visitData ? visitData.data.attributes.implantacionMarca3 : "error",
          implantacionMarca4: visitData ? visitData.data.attributes.implantacionMarca4 : "error",
          implantacionMarca5: visitData ? visitData.data.attributes.implantacionMarca5 : "error",
          implantacionMarca6: visitData ? visitData.data.attributes.implantacionMarca6 : "error",
          implantacionMarca7: visitData ? visitData.data.attributes.implantacionMarca7 : "error",
          implantacionMarca8: visitData ? visitData.data.attributes.implantacionMarca8 : "error",
          implantacionMarca9: visitData ? visitData.data.attributes.implantacionMarca9 : "error",
        }}
        onFinish={handleProfileUpdate}
      >
    <Row gutter={[16, 16]}>
    <Col md={12} lg={12} sm={24} xs={24}>
      <p>{visitData ? visitData.data.attributes.cliente.data.attributes.nombre : "error"}</p>
    </Col>
    <Col md={4} lg={4} sm={24} xs={24}>
      <Form.Item label="Lugar" name="lugar">
        <Select>
          <Option value="Tienda">Tienda</Option>
          <Option value="Showroom">Showroom</Option>
          <Option value="Otro">Otro</Option>
        </Select>
      </Form.Item>
    </Col>
    <Col md={4} lg={4} sm={24} xs={24}>
      <Form.Item label="Tipo de visita" name="tipo">
        <Select>
          <Option value="Presentación">Presentación</Option>
          <Option value="Reposición">Reposición</Option>
          <Option value="Cortesía">Cortesía</Option>
          <Option value="Apertura">Apertura</Option>
          <Option value="Evento">Evento</Option>
          <Option value="Formación">Formación</Option>
          <Option value="Otros">Otros</Option>
          <Option value="Estudio">Estudio de mercado</Option>
        </Select>
      </Form.Item>
    </Col>
  </Row>

  {/* Renderizado dinámico de las marcas */}
  {marcas.length > 0 && (
    <Collapse
      accordion
      activeKey={activeMarca}
      onChange={(key) => setActiveMarca(key)}
      style={{ marginBottom: 16, backgroundColor: 'aliceblue' }}
    >
      {marcas.map((marca, index) => {
        const selectedMarca = form.getFieldValue(`marca${index}`);
        const header = (
          <span>
            Marca {index + 1}
            {selectedMarca ? ` — ${selectedMarca}` : ''}
          </span>
        );
        return (
          <Panel header={header} key={String(index)} forceRender>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={6} lg={6}>
                <Form.Item label="Marca" name={`marca${index}`}>
                  <Select
                    showSearch
                    placeholder="Selecciona una marca"
                    onChange={() => setActiveMarca([String(index)])}
                  >
                    {marcasSelect.map((marcaSelect, idx) => (
                      <Option key={`${idx}`} value={marcaSelect}>
                        {marcaSelect}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label="Descuento %" name={`descuento${index}`}>
                  <InputNumber min={0} max={70} inputMode="decimal" style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item label="Implantación Marca" name={`implantacionMarca${index}`}>
                  <Select showSearch placeholder="Tipo de implantación" optionFilterProp="children">
                    {implantacionTypes.map((implantacionType) => (
                      <Option key={implantacionType.attributes.Code} value={implantacionType.attributes.Code}>
                        {implantacionType.attributes.Name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6}>
                <Form.Item label="Pedido" name={`pedido${index}`}>
                  <Select placeholder="Estado del pedido">
                    <Option value="No">No</Option>
                    <Option value="Pendiente">Pendiente</Option>
                    <Option value="SAP">SAP</Option>
                    <Option value="Excel">Excel</Option>
                    <Option value="B2B">B2B</Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Forma de Pago" name={`formaPago${index}`}>
                  <Select placeholder="Forma de pago">
                    <Option value="Contado">Contado</Option>
                    <Option value="a 8 días">a 8 días</Option>
                    <Option value="a 30 días">a 30 días</Option>
                    <Option value="a 60 días">a 60 días</Option>
                    <Option value="a 90 días">a 90 días</Option>
                    <Option value="a 30/60 días">a 30/60 días</Option>
                    <Option value="a 30/60/90 días">a 30/60/90 días</Option>
                    <Option value="Otros">Otros</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  label={
                    <span>
                      Comentarios de Marca{"  "}
                      <CopyOutlined onClick={() => navigator.clipboard.writeText(form.getFieldValue(`reporteMarca${index}`) || '')} size="small" />
                    </span>
                  }
                  name={`reporteMarca${index}`}
                  rules={[{ required: false, type: "string", max: 1620 }]}
                >
                  <Input.TextArea
                    placeholder="Comentarios sobre esta marca"
                    autoSize={{ minRows: 3, maxRows: 8 }}
                    onChange={(e) => setTextAreaValue(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
        );
      })}
    </Collapse>
  )}

  {/* Botón para añadir marcas */}
  <Row gutter={[16, 16]}>
    <Col md={24} lg={24} sm={24} xs={24}>
      <div style={{ display: 'flex', justifyContent: 'left', marginBottom: 30, marginTop: 10 }}>
        <Button
          style={{ marginLeft: 0, marginRight: 10 }}
          className="profile_save_btn"
          htmlType="button"
          type="primary"
          size="small"
          onClick={addMarca}
          disabled={marcas.length >= 9} // Deshabilita el botón si ya hay 9 marcas
        >
          +
        </Button> Añadir marca
      </div>
    </Col>
  </Row>

  {/* Campos adicionales: Tiene Web, Plataforma, Notas Personales 
  <Row gutter={[16, 16]}>
    <Col md={4} lg={4} sm={24} xs={24}>
      <Form.Item label="Tiene web" name="tiene_web">
        <Select>
          <Option value={false}>No</Option>
          <Option value={true}>Sí</Option>
        </Select>
      </Form.Item>
    </Col>
    <Col md={4} lg={4} sm={24} xs={24}>
      <Form.Item label="Plataforma" name="plataforma">
        <Select>
          <Option value="Prestashop">Prestashop</Option>
          <Option value="Wordpress">Wordpress</Option>
          <Option value="Shopify">Shopify</Option>
          <Option value="Magento">Magento</Option>
          <Option value="Otra">Otra</Option>
        </Select>
      </Form.Item>
    </Col>
  </Row>
*/}
  <Row gutter={[16, 16]}>
    <Col md={24} lg={24} sm={24} xs={24}>
      <Form.Item label="Notas Personales" name="reportPersonal">
        <Input.TextArea style={{ backgroundColor: 'antiquewhite' }} autoSize={{ minRows: 3, maxRows: 8 }} />
      </Form.Item>
    </Col>
  </Row>

  {/* Comentarios generales de la visita */}
  <Row gutter={[16, 16]}>
    <Col md={24} lg={24} sm={24} xs={24}>
      <Form.Item label="Comentarios generales de la visita" name="report">
        <Input.TextArea autoSize={{ minRows: 4, maxRows: 10 }} />
      </Form.Item>
    </Col>
  </Row>

  {/* Sección de fotos */}
  <Row gutter={[16, 16]}>
  <Col span={24}>
    <Form.Item label="Añadir Fotos">
      {(() => {
        const uploadProps = {
          name: "imagenes",
          multiple: true,
          fileList: imagenesNuevas,
          accept: "image/*",
          beforeUpload: async (file) => {
            const compressedFile = await compressImage(file);
            setImagenesNuevas(currentFiles => [...currentFiles, compressedFile]);
            return false;
          },
          onRemove: (file) => {
            setImagenesNuevas(currentFiles => currentFiles.filter(f => f.uid !== file.uid));
          },
        };
        return isMobile ? (
          <Upload {...uploadProps} listType="picture">
            <Button icon={<CameraOutlined />} block size="large">
              Tomar foto / añadir archivo
            </Button>
          </Upload>
        ) : (
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <CameraOutlined />
            </p>
            <p className="ant-upload-text">Haz clic o arrastra el archivo para subir</p>
            <p className="ant-upload-hint">Soporte para subida de múltiples archivos</p>
          </Dragger>
        );
      })()}
    </Form.Item>
  </Col>
</Row>

{/* Fotos ya subidas */}
<Row>
  {imagenes && imagenes.length > 0 && (
    <div>
      <p style={{ marginTop: '20px' }}>Fotos:</p>
      <div style={{ marginBottom: '20px', display: 'flex', flexWrap: 'wrap' }}>
        {imagenes.map((imagen) => {
          const imgUrl = `https://partes.teambike.com/api${imagen.attributes.url}`;
          return (
            <div key={imgUrl} style={{ position: 'relative', display: 'inline-block', marginRight: '10px' }}>
              <a href={imgUrl} target="_blank" rel="noopener noreferrer">
                <img src={imgUrl} alt="Imagen de visita" width="150" />
              </a>
              <button
                type="button"
                style={{ position: 'absolute', top: 0, right: 0, background: 'red', color: 'white' }}
                onClick={() => handleDeleteImage(imagen.id)}
              >
                X
              </button>
            </div>
          );
        })}
      </div>
    </div>
  )}
</Row>

<div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    position: 'sticky',
    bottom: 0,
    background: '#fff',
    padding: '12px 0',
    borderTop: '1px solid #f0f0f0',
    marginTop: 16,
    zIndex: 10,
    gap: 12,
  }}
>
  <Button style={{ marginLeft: 0, flex: isMobile ? 1 : 'initial' }} className="profile_save_btn" htmlType="button" type="primary" size="large" onClick={handleClientesClick} ghost>
    Volver
  </Button>
  <Button style={{ flex: isMobile ? 2 : 'initial' }} className="profile_save_btn" htmlType="submit" type="primary" size="large" loading={loading}>
    {loading ? "Actualizando..." : "Actualizar visita"}
  </Button>
</div>
</Form>
</Card>
);
};

export default UpdateVisit;